import { Button, Text } from '@shopify/polaris';
import { useNavigate, useRouteError } from 'react-router-dom';

export default function ErrorBoundaryPage() {
    const navigate = useNavigate();
    const error = useRouteError() as { error?: Error; message?: string };
    const errorMessage =
        error?.error?.message || error?.message || 'An unexpected error interrupted this page. Please try again.';

    return (
        <div className="mv-error-shell">
            <div className="mv-error-card">
                <p className="mv-error-badge">Something went wrong</p>
                <Text as="h2" variant="headingLg">
                    Unable to load this admin view
                </Text>
                <p className="mv-error-message">{errorMessage}</p>
                <div className="mv-error-actions">
                    <Button variant="primary" onClick={() => navigate('/')}>
                        Back to dashboard
                    </Button>
                    <Button onClick={() => navigate(-1)}>Go back</Button>
                </div>
            </div>
        </div>
    );
}
